import React, { useState, useEffect } from "react";
import { MessageCircle, X } from 'lucide-react';

export default function ChatWidget() {
    const [chatHidden, setChatHidden] = useState(true);
    const [showIframe, setShowIframe] = useState(false);

    // This code will be added once we decide to take it live
    // with contentful controlled flag

    // const chatWidgetQuery = useStaticQuery(graphql`
    //         query {
    //             contentfulLabel(key: { eq: "chat-widget" }) {
    //                 key
    //                 value {
    //                     raw
    //                 }
    //                 isEnabled
    //             }
    //         }
    //     `);
    // const chatWidgetEnabled = (chatWidgetQuery?.contentfulLabel.isEnabled || false);

    useEffect(() => {
        const showChatWidgetFromStorage = (localStorage.getItem("showChatWidget") || 'false').toLowerCase() === "true";
        setChatHidden(!showChatWidgetFromStorage);
    }, []);

    function toggleChat() {
        setShowIframe(!showIframe);
    }

    const agoricBlue = "#00C6C4";
    let queryParams = `?title=${encodeURIComponent("Agoric Chat")}`;
    queryParams += `&theme=${encodeURIComponent("agoric-theme")}`;
    queryParams += `&hideReasoning=${encodeURIComponent("true")}`;
    queryParams += `&useAgoricWebsiteMCP=${encodeURIComponent("true")}`;
    queryParams += `&hideTools=${encodeURIComponent("true")}`;
    queryParams += `&hideINO=${encodeURIComponent("true")}`;

    return (
        <div className={`chat-bubble ${chatHidden ? "hidden" : "show"}`}>
            <button className='chat-icon' onClick={toggleChat}>
                <MessageCircle size={32} color={agoricBlue} strokeWidth={2.5} />
            </button>
            <div className={`chat-window ${showIframe ? "show" : "hidden"}`}>
                <div className='chat-header'>
                    <button onClick={toggleChat} className='close-button'>
                        <X size={20} color="#fff" strokeWidth={2} />
                    </button>
                </div>
                <div className='chat-body'>
                    <iframe
                    src={`https://chat.agoric.net${queryParams}`}
                    title="Agoric Community Chat"
                    className="chat-iframe"
                    sandbox="allow-scripts allow-same-origin allow-forms"
                    style={{ border: 'none', width: '100%', height: '100%' }}
                    ></iframe>
                </div>
            </div>
        </div>
    );
}